import React, { useCallback } from "react";
import PinIcon from "_c/icon/Pin";
import DenyIcon from "_c/icon/Deny";
import {
  LinkButton,
  InnerWrap,
  RateWrap,
  RatingCount,
  Name,
  Popup,
  Content,
  Rating,
  AddressWrap,
  CloseButton,
} from "./styled";
import { Link } from "react-router-dom";
import { normalizeRating } from "@/utils";
import Avatar from "_c/Avatar";
import { PuffPreloader } from "_c/preloader";
import { MasterAPI } from "@/api/master";
import PT from "prop-types";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { Popup as MapPopup } from "_c/modules/geo/Map";
import { SEARCH_NS as ns } from "@/i18n/ns";
import { useLoader } from "@/hooks/useLoader";

const MasterPopup = ({ coords, id, onClose, t }) => {
  const loader = useCallback(() => MasterAPI.findById(id), [id]);
  const { data: master, isLoading } = useLoader({
    loader,
    defaultLoadingState: "loading",
  });
  return (
    <MapPopup className="master-search-popup" anchor="top" coordinates={coords}>
      <Popup>
        {isLoading || !master ? (
          <PuffPreloader centered />
        ) : (
          <>
            <CloseButton title={t("common:close")} onClick={() => onClose()}>
              <DenyIcon color="white" />
            </CloseButton>
            <InnerWrap>
              <Avatar
                size="md"
                online={master.user.online}
                reverseColors
                sex={master.user.sex}
                avatar={master.user.avatar}
              />
              <Content>
                <Name>{master.user.first_name}</Name>
                <RateWrap>
                  <Rating>{normalizeRating(master.rate)}</Rating>
                  <RatingCount>
                    {(master.reviews_count || 0) +
                      " " +
                      t("common:review", {
                        count: master.reviews_count || 0,
                      })}
                  </RatingCount>
                </RateWrap>
              </Content>
            </InnerWrap>
            <AddressWrap>
              <PinIcon width="13" color="white" />
              <address>{master.location_hr}</address>
            </AddressWrap>
            <LinkButton
              small
              greenish
              as={Link}
              to={LinkGenerator.masterProfile(master._id)}
            >
              {t(`${ns}:to_profile`)}
            </LinkButton>
          </>
        )}
      </Popup>
    </MapPopup>
  );
};
MasterPopup.propTypes = {
  Mapbox: PT.object,
  id: PT.string,
  coords: PT.array,

  t: PT.func.isRequired,
  onClose: PT.func,
};

export default MasterPopup;
